import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/how-to-play/page.tsx");
